
import { defineComponent, ref, reactive, toRefs, onMounted, computed } from 'vue'
import { DoubleRightOutlined } from '@ant-design/icons-vue'
import router from '@/router/index'
import { useRoute } from 'vue-router'
import Navatop from '@/components/navtop.vue'
import api from '@/api/allApi'
import Table from '@/components/table.vue'
import Nodata from '@/components/page/nodata.vue'
export default defineComponent({
  props: {
    itemdata: {
      type: Object,
      default: () => {
        return {}
      }
    },
    pageSourceData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  components: { Table, Nodata },
  setup(props, context) {
    const pageData: any = reactive({
      data: [],
      data2: [],
      columns: [],
      columns2: [],
      Ms: '',
      TotalAmount1: 0,
      TotalRatio1: 0,
      TotalAmount2: 0,
      TotalRatio2: 0,
      spinning: true
    })
    pageData.columns = [
      {
        title: '买入前五营业部',
        dataIndex: 'SalesDepartmentName',
        key: 'SalesDepartmentName',
        width: '240px',
        slots: { customRender: 'ellipsis' },
        ellipsis: true
      },
      {
        title: '买入金额（元）',
        dataIndex: 'BuySum',
        key: 'BuySum',
        width: '100px',
        slots: { customRender: 'peopleCount' }
      },
      {
        title: '占金额比',
        dataIndex: 'BuySaleRatio',
        key: 'BuySaleRatio',
        width: '100px',
        slots: { customRender: 'nocolorincrease' }
      },
      {
        title: '卖出金额（元）',
        dataIndex: 'SaleSum',
        key: 'SaleSum',
        width: '100px',
        slots: { customRender: 'peopleCount' }
      },
      {
        title: '占金额比',
        dataIndex: 'SecondRatio',
        key: 'SecondRatio',
        width: '100px',
        slots: { customRender: 'nocolorincrease' }
      }
    ]
    pageData.columns2 = [
      {
        title: '卖出前五营业部',
        dataIndex: 'SalesDepartmentName',
        key: 'SalesDepartmentName',
        width: '240px',
        slots: { customRender: 'ellipsis' },
        ellipsis: true
      },
      {
        title: '买入金额（元）',
        dataIndex: 'BuySum',
        key: 'BuySum',
        width: '100px',
        slots: { customRender: 'peopleCount' }
      },
      {
        title: '占金额比',
        dataIndex: 'SecondRatio',
        key: 'SecondRatio',
        width: '100px',
        slots: { customRender: 'nocolorincrease' }
      },
      {
        title: '卖出金额（元）',
        dataIndex: 'SaleSum',
        key: 'SaleSum',
        width: '100px',
        slots: { customRender: 'peopleCount' }
      },
      {
        title: '占金额比',
        dataIndex: 'BuySaleRatio',
        key: 'BuySaleRatio',
        width: '100px',
        slots: { customRender: 'nocolorincrease' }
      }
    ]
    pageData.data = computed(() => {
      return setData()
    })
    pageData.data2 = computed(() => {
      return setData2()
    })
    function setData() {
      const LHRank = (props.pageSourceData || {}).LHRank || {}
      const _data = ((LHRank || {}).Detail || []).filter((item: any) => item.Type === 1)
      if ((_data || []).length && (_data[0].Details || []).length) {
        pageData.Ms = window.moment(LHRank.TradeDay * 1000).format('YYYY-MM-DD') + ' 上榜原因：' + LHRank.Ms
        pageData.TotalAmount1 = _data[0].TotalAmount
        pageData.TotalRatio1 = _data[0].TotalRatio * 100
        _data[0].Details.forEach((item: any, i: number) => {
          item.index = 'lhbd1' + i
          item.BuySaleRatio = parseFloat(item.BuySaleRatio).toString() !== 'NaN' ? item.BuySaleRatio * 100 : null
          item.SecondRatio = parseFloat(item.SecondRatio).toString() !== 'NaN' ? item.SecondRatio * 100 : null
        })
      }
      pageData.spinning = false
      return (_data[0] || {}).Details || []
    }
    function setData2() {
      const LHRank = (props.pageSourceData || {}).LHRank || {}
      const _data = ((LHRank || {}).Detail || []).filter((item: any) => item.Type === 2)
      if ((_data || []).length && (_data[0].Details || []).length) {
        pageData.TotalAmount2 = _data[0].TotalAmount
        pageData.TotalRatio2 = _data[0].TotalRatio * 100
        _data[0].Details.forEach((item: any, i: number) => {
          item.index = 'lhbd2' + i
          item.SecondRatio = parseFloat(item.SecondRatio).toString() !== 'NaN' ? item.SecondRatio * 100 : null
          item.BuySaleRatio = parseFloat(item.BuySaleRatio).toString() !== 'NaN' ? item.BuySaleRatio * 100 : null
        })
      }
      pageData.spinning = false
      return (_data[0] || {}).Details || []
    }
    return {
      ...toRefs(pageData)
    }
  }
})
